export default __webpack_public_path__ + "static/media/2367.b3f6cb1c.png";